import { useState } from 'react';

// Self-hosted image thumbnail with a graceful, on-brand fallback. When the
// image is missing (404 / not yet generated) or fails to load, we render a
// light gradient tile with the item's emoji centered — never a broken image.
// Shared by the exercise + equipment index cards and detail-page heroes.
export function Thumb({
  src,
  alt,
  emoji,
  className = '',
  imgClassName = '',
  contain = false,
}: {
  src?: string | null;
  alt: string;
  emoji: string;
  className?: string;
  imgClassName?: string;
  // `contain` shows the whole image (product shots on white) instead of a
  // cover-crop; the rest use cover so photos fill the tile.
  contain?: boolean;
}) {
  const [broken, setBroken] = useState(false);
  const showImage = src && !broken;
  const bg = contain ? 'bg-white' : 'bg-gradient-to-br from-elevated to-surface-2';

  return (
    <div className={`relative overflow-hidden ${bg} ${className}`}>
      {showImage ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          onError={() => setBroken(true)}
          className={`h-full w-full ${contain ? 'object-contain' : 'object-cover'} ${imgClassName}`}
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <span className="text-4xl opacity-60" aria-hidden="true">{emoji}</span>
        </div>
      )}
    </div>
  );
}
